import { useEffect, useState } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Login from "./Components/Auth/Login";
import Forget from "./Components/Auth/Forget";
import Register from "./Components/Auth/Register";
import FrontPage from "./Components/FrontPage/FrontPage";

import Profile from "./Components/AdminProfile/Profile";

import { MootAllApplication } from "./Components/MootCourtPage/MootAllApplication";
import SingleMootUser from "./Components/MootCourtPage/SingleMootUser";
import CreateDraft from "./Components/LegalDraft/CreateDraft";
import AllLegalDrafts from "./Components/LegalDraft/AllDrafts";
import UpdateDraft from "./Components/LegalDraft/UpdateDraft";
import SingleDraftPage from "./Components/LegalDraft/SingleDraftPage";
import AllArticles from "./Components/articlesPage/AllArticles";
import CreateArticle from "./Components/articlesPage/CreateArticles";
import AllBlogs from "./Components/blogsPage/AllBlogs";
import CreateBlogs from "./Components/blogsPage/CreateBlogs";
import { CreateQueCategory } from "./Components/QueAndAns/CreateQueCategory";
import UpdateBlogs from "./Components/blogsPage/UpdateBlogs";
import UpdateArticles from "./Components/articlesPage/UpdateArticles";
import CreateNews from "./Components/NewsPage/CreateNews";
import ManageAllNews from "./Components/NewsPage/ManageNews";
import UpdateNews from "./Components/NewsPage/UpdateNews";
import CreateVideo from "./Components/videos/CreateVideo";
import UpdateVideo from "./Components/videos/UpdateVideo";
import ManageAllVideos from "./Components/videos/ManageVideos";
import ManageAllJobs from "./Components/jobpage/ManageJob";
import UpdateJob from "./Components/jobpage/UpdateJob";
import MeetUsers from "./Components/MeetUsers/MeetUsers";
import EmailSubscriber from "./Components/MeetUsers/EmailSubscriber";
import ContactUs from "./Components/AllContactData/Contact";
import HomeBanner from "./Components/homebanner/bannerMange";
import CreateHomeBanner from "./Components/homebanner/CreateBanner";
import AllJobSeekerUsers from "./Components/AllUsers/AllUsers";
import UserDetailPage from "./Components/AllUsers/UserDetailPage";
import { CreateAwardsCategory } from "./Components/Awards/AwardCategory";
import AllCandidates from "./Components/Awards/Candidates";
import CandidateDetails from "./Components/Awards/CandidateDetails";
import AllVoters from "./Components/Awards/Voter";
import VoteResults from "./Components/Awards/VoteResult";
import UpdateCandidate from "./Components/Awards/UpdateCandidate";
import DraftPaid from "./Components/LegalDraft/DraftPaid";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const superAdminLawvs = sessionStorage.getItem("superAdminLawvs");
    if (superAdminLawvs) {
      const parsedUserInfo = JSON.parse(superAdminLawvs);
      if (parsedUserInfo.data.token) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  return (
    <>
      <div className="App">
        <Router>
          <Routes>
            {isAuthenticated ? (
              <>
                <Route path="/" element={<FrontPage />} />
                <Route
                  path="/moot-application"
                  element={<MootAllApplication />}
                />
                <Route
                  path="/admin/moot-user/:id"
                  element={<SingleMootUser />}
                />
                {/* All drafts routes............. */}
                <Route path="/Create-legal-draft" element={<CreateDraft />} />
                <Route path="/All-legal-draft" element={<AllLegalDrafts />} />
                <Route path="/update-draft/:slug" element={<UpdateDraft />} />
                <Route
                  path="/single-draft/:slug"
                  element={<SingleDraftPage />}
                />
                <Route path="/paid-draft" element={<DraftPaid />} />

                {/* ............All blogs routes............. */}
                <Route path="/get-all-story" element={<AllBlogs />} />
                <Route path="/create-blog" element={<CreateBlogs />} />
                <Route path="/update-blogs/:slug" element={<UpdateBlogs />} />
                {/* /...........All article routes............. */}
                <Route path="/get-all-articles" element={<AllArticles />} />
                <Route path="/create-article" element={<CreateArticle />} />
                <Route
                  path="/update-article/:slug"
                  element={<UpdateArticles />}
                />
                {/* .......All News Routes....... */}
                <Route path="/create-news" element={<CreateNews />} />
                <Route path="/manage-news" element={<ManageAllNews />} />
                <Route path="/update-news/:slug" element={<UpdateNews />} />

                <Route
                  path="/create-category"
                  element={<CreateQueCategory />}
                />
                <Route path="/all-Jobs" element={<ManageAllJobs />} />
                <Route path="/update-Job/:id" element={<UpdateJob />} />

                <Route path="/create-video" element={<CreateVideo />} />
                <Route path="/update-video/:_id" element={<UpdateVideo />} />
                <Route path="/manage-videos" element={<ManageAllVideos />} />

                <Route path="/admin-profile" element={<Profile />} />
                <Route path="*" element={<Navigate to="/" />} />
                <Route path="/user-details/:id" element={<UserDetailPage />} />
                <Route
                  path="/jobseeker-users"
                  element={<AllJobSeekerUsers />}
                />
                <Route path="/meet-users-get" element={<MeetUsers />} />

                <Route path="/email-subscriber" element={<EmailSubscriber />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/home-banner" element={<HomeBanner />} />
                <Route path="/create-banner" element={<CreateHomeBanner />} />
                {/* ................elections routes starts.........*/}
                <Route
                  path="/create-award-category"
                  element={<CreateAwardsCategory />}
                />
                <Route path="/all-candidates" element={<AllCandidates />} />
                <Route path="/all-voters" element={<AllVoters />} />
                <Route path="/candidate-results" element={<VoteResults />} />
                <Route
                  path="/admin/candidate/:id"
                  element={<CandidateDetails />}
                />
                <Route
                  path="/updateBYadmin/candidate/:id"
                  element={<UpdateCandidate />}
                />

                {/* ................elections routes ends.........*/}
              </>
            ) : (
              <>
                <Route path="/login" element={<Login />} />
                {/* <Route path="/" element={<FrontPage />} /> */}

                <Route path="/forget" element={<Forget />} />
                <Route path="/register" element={<Register />} />
                <Route path="*" element={<Navigate to="/login" />} />
              </>
            )}
          </Routes>
        </Router>
      </div>
    </>
  );
}

export default App;
